const NOT_ASSIGNED_OPTION = { value: null, label: 'Not assigned' };

export const prepareValues = customers => {
  const initial = [NOT_ASSIGNED_OPTION];
  return customers.reduce((acct, d) => {
    acct.push({ value: d.id, label: d.full_name });
    return acct;
  }, initial);
};

export const valueFromId = (opts, id) => opts.find(o => o.value === id);



// WEBPACK FOOTER //
// ./app/javascript/design/routes/Workdesk/components/ProjectAdminsPicker/utils.js